import { render, staticRenderFns } from "./QaList.vue?vue&type=template&id=061010e7&scoped=true&"
import script from "./QaList.vue?vue&type=script&lang=js&"
export * from "./QaList.vue?vue&type=script&lang=js&"
import style0 from "./QaList.vue?vue&type=style&index=0&id=061010e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061010e7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('061010e7')) {
      api.createRecord('061010e7', component.options)
    } else {
      api.reload('061010e7', component.options)
    }
    module.hot.accept("./QaList.vue?vue&type=template&id=061010e7&scoped=true&", function () {
      api.rerender('061010e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gift/basic/qa/QaList.vue"
export default component.exports